/**
 * Footer newsletter signup — Gravity Forms bridge (client).
 *
 * The footer form is plain HTML/CSS for design fidelity. This script
 * intercepts the submit, sends the email to our REST route
 * (wp-json/umces/v1/newsletter-signup), and shows inline feedback.
 * PHP-side: includes/newsletter-gravity-form.php.
 */
(function () {
    'use strict';

    var form = document.querySelector('.block-site-wide-footer__newsletter-form');
    if (!form) return;
    var input = form.querySelector('.block-site-wide-footer__newsletter-input');
    if (!input) return;

    // Create or reuse a status message element inside the form.
    var status = form.querySelector('.block-site-wide-footer__newsletter-message');
    if (!status) {
        status = document.createElement('div');
        status.className = 'block-site-wide-footer__newsletter-message';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        form.appendChild(status);
    }

    function setStatus(msg, kind) {
        status.textContent = msg || '';
        // kind: 'success' | 'error' | '' (pending). CSS styles via [data-kind].
        if (kind) {
            status.setAttribute('data-kind', kind);
        } else {
            status.removeAttribute('data-kind');
        }
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (typeof window.umces_newsletter === 'undefined') {
            setStatus('Signup is temporarily unavailable. Please try again later.', 'error');
            return;
        }

        var email = (input.value || '').trim();
        if (!email) {
            setStatus('Please enter your email address.', 'error');
            input.focus();
            return;
        }

        setStatus('Submitting…', '');
        form.classList.add('is-submitting');

        fetch(window.umces_newsletter.rest_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.umces_newsletter.nonce
            },
            body: JSON.stringify({ email: email })
        })
            .then(function (response) {
                return response.json().then(function (body) {
                    return { httpOk: response.ok, body: body };
                });
            })
            .then(function (result) {
                form.classList.remove('is-submitting');
                var body = result.body || {};
                if (result.httpOk && body.ok) {
                    setStatus(body.message || 'Thanks for subscribing!', 'success');
                    input.value = '';
                } else {
                    setStatus(body.message || 'Something went wrong. Please try again.', 'error');
                }
            })
            .catch(function () {
                form.classList.remove('is-submitting');
                setStatus('Network error. Please try again.', 'error');
            });
    });
})();
